import { Star, BadgeCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { TESTIMONIALS } from "./constants";

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 lg:py-32 bg-[#052B38]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl mb-14">
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-amber-400/90 mb-5">
            Kind Words
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white leading-tight">
            What clients say.
          </h2>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="h-full flex flex-col rounded-3xl border border-white/10 bg-[#073B4C] p-8 transition-all duration-300 hover:-translate-y-1 hover:border-amber-400/40 hover:shadow-2xl hover:shadow-amber-500/5"
              >
                <div className="flex gap-1 mb-5" aria-label="5 star review">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={15} className="fill-amber-400 text-amber-400" />
                  ))}
                </div>
                <blockquote className="flex-1 text-sm sm:text-base text-slate-300 leading-relaxed">
                  "{t.quote}"
                </blockquote>
                <figcaption className="mt-7 pt-6 border-t border-white/10 flex items-center gap-4">
                  <div className="h-12 w-12 shrink-0 rounded-full bg-amber-400/15 border border-amber-400/40 flex items-center justify-center font-display font-semibold text-amber-300">
                    {t.initials}
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-white truncate">{t.name}</p>
                    <p className="text-xs text-slate-500 mt-0.5">{t.role}</p>
                  </div>
                  <span className="ml-auto flex items-center gap-1 text-emerald-400">
                    <BadgeCheck size={16} />
                    <span className="hidden xl:inline text-[11px] font-mono uppercase tracking-wider">
                      Verified
                    </span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
